<template>
  <async-btn
    :task="task"
    icon="fa fa-lock"
    :label="`Login to ${platform}`"
    rounded
    @click="login"
    class="full-width"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Credentials } from '@/iam/external';
import AsyncBtn from '@/components/AsyncBtn.vue';
import credentialsProvider from './delegating-credentials-provider';

interface Data {
  task: Promise<Credentials|null>|null,
}

export default defineComponent({
  emits: ['update:modelValue'],
  components: { AsyncBtn },
  props: {
    platform: {
      type: String,
      required: true,
    },
    permissions: {
      type: Array as () => string[],
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    login(): void {
      this.task = credentialsProvider.getCredentials(
        this.platform,
        { type: 'OAUTH', version: '2.0' },
        this.permissions,
      );
      this.task.then((credentials) => {
        this.$emit('update:modelValue', credentials);
      });
    },
  },
});
</script>
